(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7880],{

/***/ 7306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InfoBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSessionStorageState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11612);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62832);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93407);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_5__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






function InfoBanner(props) {
    var ref = _slicedToArray((0,_hooks_useSessionStorageState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("onTable"), 1), onTable = ref[0];
    var website = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().website;
    if (!onTable || !website) return null;
    var importantMessageTableText = website.navbarConfiguration.importantMessageTableText;
    if (!importantMessageTableText) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().inner),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_5___default().description),
                    children: importantMessageTableText
                })
            })
        })
    });
};


/***/ }),

/***/ 76530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InteligentLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_scrollTo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55192);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




function InteligentLink(props) {
    var moveScrollTo = props.moveScrollTo;
    var _to;
    var href = (_to = props.to) !== null && _to !== void 0 ? _to : props.href;
    var handledClick = function() {
        if (moveScrollTo) (0,_helpers_misc_scrollTo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            element: moveScrollTo
        });
    };
    if (href.startsWith("/")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                style: props.style,
                className: props.className,
                onClick: handledClick,
                children: props.children
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            style: props.style,
            className: props.className,
            onClick: handledClick,
            children: props.children
        });
    }
};


/***/ }),

/***/ 69528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79961);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




function Loading(props) {
    var color = props.color, className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().item), className),
            style: {
                borderColor: color
            }
        })
    });
};


/***/ }),

/***/ 69840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoadingText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/helpers/misc/hexToRgba.ts
function hexToRgba(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
    if (alpha === 0 || alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
    }
};

// EXTERNAL MODULE: ./src/components/LoadingText/styles.module.css
var styles_module = __webpack_require__(68732);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/LoadingText/index.tsx




function LoadingText(param) {
    var _lineHeight = param.lineHeight, lineHeight = _lineHeight === void 0 ? 20 : _lineHeight, _lines = param.lines, lines = _lines === void 0 ? 1 : _lines, _widthPercentage = param.widthPercentage, widthPercentage = _widthPercentage === void 0 ? 100 : _widthPercentage, _useAnimationDelay = param.useAnimationDelay, useAnimationDelay = _useAnimationDelay === void 0 ? true : _useAnimationDelay, _color = param.color, color = _color === void 0 ? "#e0e0e0" : _color, _highlightColor = param.highlightColor, highlightColor = _highlightColor === void 0 ? "#f5f5f5" : _highlightColor;
    var ref = (0,react.useState)(0), animationDelay = ref[0], setAnimationDelay = ref[1];
    (0,react.useEffect)(function() {
        if (useAnimationDelay) setAnimationDelay(Math.random() * 0.5);
    }, [
        useAnimationDelay
    ]);
    var arr = Array.from(Array(lines).keys());
    var backgroundImage = "linear-gradient(90deg, ".concat(hexToRgba(highlightColor, 0), " 0, ").concat(hexToRgba(highlightColor, 0.2), " 20%, ").concat(hexToRgba(highlightColor, 0.5), " 60%, ").concat(hexToRgba(highlightColor, 0), ")");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: arr.map(function(key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).line,
                    style: {
                        height: lineHeight,
                        width: "".concat(widthPercentage, "%"),
                        backgroundColor: color
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).after,
                        style: {
                            animationDelay: "".concat(String(animationDelay).substring(0, 4), "s"),
                            backgroundImage: backgroundImage
                        }
                    })
                })
            }, key);
        })
    });
};


/***/ }),

/***/ 77591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SixDigitInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var autobind_decorator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88572);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21985);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}






var _Component, _SixDigitInput;
var _class, _dec, _dec1, _dec2, _dec3;
var SixDigitInput = ((_class = (_SixDigitInput = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(SixDigitInput, _superClass);
    var _super = _createSuper(SixDigitInput);
    function SixDigitInput(props) {
        _classCallCheck(this, SixDigitInput);
        var _this;
        _this = _super.call(this, props);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
        _this.inputsRefs = {};
        lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(props.digits).forEach(function(index) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
            _this.inputsRefs["input_".concat(index)] = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createRef();
        });
        return _this;
    }
    var _proto = SixDigitInput.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'autoFocus' does not exist on type 'Reado... Remove this comment to see the full error message
        if (this.props.autoFocus) {
            this.focus();
        }
    };
    _proto.focus = function focus() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        if (this.props.value) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange("");
        }
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
        this.inputsRefs["input_0"].current.focus();
    };
    _proto.getNextIndex = function getNextIndex(value) {
        if (!value) return 0;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'digits' does not exist on type 'Readonly... Remove this comment to see the full error message
        if (value.length + 1 > this.props.digits) return 0;
        return value.length;
    };
    _proto.focusNext = function focusNext() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        var value = this.props.value;
        var index = this.getNextIndex(value);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
        this.inputsRefs["input_".concat(index)].current.focus();
    };
    _proto.isReady = function isReady() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        return (this.props.value || "").length === this.props.digits;
    };
    _proto.onChange = function onChange(event, index) {
        var _this = this;
        var value = event.target.value || "";
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
        var oldValue = this.props.value || "";
        var newValue = oldValue + value;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'regex' does not exist on type 'Readonly<... Remove this comment to see the full error message
        newValue = newValue.replace(this.props.regex, "");
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'digits' does not exist on type 'Readonly... Remove this comment to see the full error message
        if (newValue.length > this.props.digits) {
            var last = newValue[newValue.length - 1];
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange(last);
        } else {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange(newValue);
        }
        setTimeout(function() {
            if (_this.isReady()) {
                var _this1 = _this;
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
                _this.inputsRefs["input_".concat(index)].current.blur();
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'onReady' does not exist on type 'Readonl... Remove this comment to see the full error message
                setTimeout(function() {
                    return _this1.props.onReady(newValue);
                }, 200);
            } else {
                _this.focusNext();
            }
        }, 1);
    };
    _proto.onKeyDown = function onKeyDown(event, index) {
        if (event.key === "Backspace") {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
            var newVal = (this.props.value || "1").slice(0, -1);
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            this.props.onChange(newVal);
            setTimeout(this.focusNext, 1);
        }
    };
    _proto.renderInputs = function renderInputs() {
        var _this = this;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'digits' does not exist on type 'Readonly... Remove this comment to see the full error message
        return lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(this.props.digits).map(function(index) {
            var _this2 = _this;
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
            var value = (_this.props.value || "")[index] || "";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            value: value.toUpperCase(),
                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'inputsRefs' does not exist on type 'SixD... Remove this comment to see the full error message
                            ref: _this.inputsRefs["input_".concat(index)],
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().input),
                            placeholder: "\u2022",
                            onChange: function(event) {
                                return _this2.onChange(event, index);
                            },
                            onKeyDown: function(event) {
                                return _this2.onKeyDown(event, index);
                            }
                        })
                    }),
                    index === _this.props.digits / 2 - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().divider),
                        children: "-"
                    }) : null
                ]
            }, index);
        });
    };
    _proto.render = function render() {
        var className = this.isReady() ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().ready) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: className,
                    children: [
                        this.props.head,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputs),
                            onClick: this.focus,
                            children: this.renderInputs()
                        }),
                        this.props.bottom
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "os-input-error",
                    children: this.props.errorMessage
                })
            ]
        });
    };
    return SixDigitInput;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component), _SixDigitInput.propTypes = {
    value: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    autoFocus: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    onReady: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    digits: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    errorMessage: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    regex: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
    head: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    bottom: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
}, _SixDigitInput.defaultProps = {
    autoFocus: true,
    digits: 6,
    regex: /[^0-9A-Za-z]/g,
    onReady: function() {}
}, _SixDigitInput)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", []), _applyDecoratedDescriptor(_class.prototype, "focus", [
    autobind_decorator__WEBPACK_IMPORTED_MODULE_5__["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _dec2 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec3 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", []), _applyDecoratedDescriptor(_class.prototype, "focusNext", [
    autobind_decorator__WEBPACK_IMPORTED_MODULE_5__["default"],
    _dec2,
    _dec3
], Object.getOwnPropertyDescriptor(_class.prototype, "focusNext"), _class.prototype), _class);



/***/ }),

/***/ 62280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getQueryObject; }
/* harmony export */ });
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17673);

function getQueryObject(router) {
    var ref;
    var queryString = (ref = router.asPath.split("?")[1]) !== null && ref !== void 0 ? ref : "";
    return (0,querystring__WEBPACK_IMPORTED_MODULE_0__.parse)(queryString);
};


/***/ }),

/***/ 29453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

function inIframe() {
    if ((0,_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return false;
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (inIframe());


/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollTo; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var supportsNativeSmoothScroll = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function scrollTo(param) {
    var element = param.element, _top = param.top, top = _top === void 0 ? 0 : _top, _left = param.left, left = _left === void 0 ? 0 : _left;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) {
        return;
    }
    element = (element === null || element === void 0 ? void 0 : element.scrollTo) && typeof (element === null || element === void 0 ? void 0 : element.scrollTo) === "function" ? element : window;
    if (!element) {
        return;
    }
    if (supportsNativeSmoothScroll) {
        element.scrollTo({
            top: top,
            left: left,
            behavior: "smooth"
        });
        return;
    }
    try {
        element.scrollTo(left, top);
    } catch (error) {
        try {
            element.scrollTop = top;
            element.scrollLeft = left;
        } catch (error) {}
    }
};


/***/ }),

/***/ 77712:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var sleep = function(time) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, time);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (sleep);


/***/ }),

/***/ 5455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsSpecialLayout; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function useIsSpecialLayout() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (router.query.isChat === "true") {
        return "chat";
    }
    return false;
};


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyboardEvent(combination, callback) {
    var keysToMatch = combination.toLowerCase().split("+");
    var keys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    callbackRef.current = callback;
    var checkEvent = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysToMatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyToMatch = _step.value;
                if (!keys[keyToMatch]) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current();
    };
    var onKeyDown = function(event) {
        if (event && event.key) {
            var key = event.key.toLowerCase();
            keys[key] = true;
        }
    };
    var onKeyUp = function(event) {
        if (event && event.key) {
            checkEvent();
            var key = event.key.toLowerCase();
            delete keys[key];
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keyup", onKeyUp);
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keyup", onKeyUp);
            document.removeEventListener("keydown", onKeyDown);
        };
    });
};


/***/ }),

/***/ 31778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLogo; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
/* harmony import */ var _packages_apollo_hooks_lib_useApolloQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28613);
/* harmony import */ var _packages_apollo_hooks_lib_useApolloQuery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_packages_apollo_hooks_lib_useApolloQuery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query viewerCountryCode {\n        viewerCountryCode\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useLogo(param) {
    var darkMode = param.darkMode, countryCode = param.countryCode;
    var ref = _packages_apollo_hooks_lib_useApolloQuery__WEBPACK_IMPORTED_MODULE_0___default()({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject()),
        omit: (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
        partial: true
    }), result = ref.viewerCountryCode;
    var ref1;
    var viewerCountryCode = (ref1 = result === null || result === void 0 ? void 0 : result.viewerCountryCode) !== null && ref1 !== void 0 ? ref1 : countryCode;
    if (viewerCountryCode === "MX") {
        if (darkMode) {
            return "https://s3.amazonaws.com/orion-eat-app-files/orioneat-prod%2FnLqPFjwg9bDARQoPv-Getjusto_Oscuro.svg";
        }
        return "https://s3.amazonaws.com/orion-eat-app-files/orioneat-prod%2FdNRSZqaCSK6NYKEFZ-Getjusto_Blanco.svg";
    }
    if (darkMode) return "/logo-dark.svg";
    return "/logo-white.svg";
};


/***/ }),

/***/ 3221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 18368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteLayout; }
/* harmony export */ });
function useWebsiteLayout(website) {
    var layout = website && website.layout ? website.layout : "default";
    var menuLayout = website && website.menuLayout ? website.menuLayout : "v1";
    var productsLayout = website && website.productsLayout ? website.productsLayout : "long";
    var checkoutLayout = website && website.checkoutLayout ? website.checkoutLayout : "v1";
    var headerLayout = website && website.headerLayout ? website.headerLayout : "default";
    return {
        layout: layout,
        menuLayout: menuLayout,
        productsLayout: productsLayout,
        checkoutLayout: checkoutLayout,
        headerLayout: headerLayout
    };
};


/***/ }),

/***/ 41763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ PREFIX_EXT_TERMS; }
/* harmony export */ });
var PREFIX_EXT_TERMS = "website_";


/***/ }),

/***/ 56129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _i18n_helpers_terms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41763);

var getJustoTerms = function(terms) {
    return Object.keys(terms).filter(function(term) {
        return !term.startsWith(_i18n_helpers_terms_constants__WEBPACK_IMPORTED_MODULE_0__/* .PREFIX_EXT_TERMS */ .V);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (getJustoTerms);


/***/ }),

/***/ 90506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _i18n_helpers_terms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41763);

var removePrefix = function(termType) {
    var justoTerms = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var termTypeWithoutPrefix = termType.replace(_i18n_helpers_terms_constants__WEBPACK_IMPORTED_MODULE_0__/* .PREFIX_EXT_TERMS */ .V, "");
    var hasPrefixWebsite = termType !== termTypeWithoutPrefix;
    var addTerm = hasPrefixWebsite && !justoTerms.includes(termTypeWithoutPrefix) || !hasPrefixWebsite;
    return [
        termTypeWithoutPrefix,
        addTerm
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (removePrefix);


/***/ }),

/***/ 77880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Website; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/InfoBanner/index.tsx
var InfoBanner = __webpack_require__(7306);
// EXTERNAL MODULE: ./src/components/LoadingText/index.tsx + 1 modules
var LoadingText = __webpack_require__(69840);
// EXTERNAL MODULE: ./src/helpers/misc/isIFrame.ts
var isIFrame = __webpack_require__(29453);
// EXTERNAL MODULE: ./src/hooks/useIsSpecialLayout.ts
var useIsSpecialLayout = __webpack_require__(5455);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/DownloadApp/isMobile.ts

function isMobile() {
    if ((0,isServerSide/* default */.Z)()) return false;
    return typeof window.orientation !== "undefined";
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/useApolloQuery.js
var useApolloQuery = __webpack_require__(28613);
var useApolloQuery_default = /*#__PURE__*/__webpack_require__.n(useApolloQuery);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/useMutate.js
var useMutate = __webpack_require__(7536);
var useMutate_default = /*#__PURE__*/__webpack_require__.n(useMutate);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Coupon/styles.module.css
var styles_module = __webpack_require__(33714);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Coupon/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getCouponUserPreferences($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          couponCode\n          cart {\n            websiteId\n            couponStatus {\n              code\n              description\n              errorMessage\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        mutation setUserPreferencesCoupon($websiteId: ID, $couponCode: String) {\n          preferences: setUserPreferences(websiteId: $websiteId, couponCode: $couponCode) {\n            _id\n            couponCode\n            cart {\n              websiteId\n              couponStatus {\n                code\n                description\n                errorMessage\n              }\n            }\n          }\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










function Coupon(props) {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var couponCode = router.query.coupon;
    var preferences = useApolloQuery_default()({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: !couponCode
    }).preferences;
    var mutate = useMutate_default()();
    var setCode = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref1, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,lib["default"])(_templateObject1()),
                            variables: {
                                websiteId: websiteId,
                                couponCode: couponCode
                            }
                        });
                    case 3:
                        response = _ctx.sent;
                        if (!(!response || !response.preferences || !response.preferences.cart || !response.preferences.cart.couponStatus || !response.preferences.cart.couponStatus.code)) {
                            _ctx.next = 8;
                            break;
                        }
                        logger/* default.warn */.Z.warn("No existe informaci\xf3n de cup\xf3n", response.preferences);
                        alert("Cup\xf3n no encontrado");
                        return _ctx.abrupt("return");
                    case 8:
                        if ((ref = preferences.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.couponStatus) === null || ref1 === void 0 ? void 0 : ref1.errorMessage) {
                            alert(preferences.cart.couponStatus.errorMessage);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setCode() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!couponCode) return;
        setCode();
        router.push({
            query: {
                coupon: ""
            }
        });
    }, []);
    if (!couponCode) return null;
    if (!preferences.cart || !preferences.cart.couponStatus || !preferences.cart.couponStatus.code) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).description,
                        children: preferences.cart.couponStatus.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).code,
                        children: preferences.cart.couponStatus.code
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Demo/styles.module.css
var Demo_styles_module = __webpack_require__(61806);
var Demo_styles_module_default = /*#__PURE__*/__webpack_require__.n(Demo_styles_module);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Demo/index.tsx





function Demo(props) {
    var t = (0,useTranslation/* useTranslation */.$)("website", {
        keyPrefix: "layout.demo"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Demo_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Demo_styles_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Demo_styles_module_default()).description,
                    children: t("labelDescription")
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(12284);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/DownloadApp/openApp.ts

function OpenApp(param) {
    var code = param.code, playStoreURL = param.playStoreURL, appStoreURL = param.appStoreURL;
    var url = navigator.platform.match(/iPhone|iPod|iPad/) ? appStoreURL : playStoreURL;
    if ((0,isServerSide/* default */.Z)()) return null;
    window.open(url);
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/DownloadApp/styles.module.css
var DownloadApp_styles_module = __webpack_require__(802);
var DownloadApp_styles_module_default = /*#__PURE__*/__webpack_require__.n(DownloadApp_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/DownloadApp/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function DownloadApp(props) {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.downloadApp"
    }).t;
    var ref = (0,useInitialData/* default */.Z)(), website = ref.website, config = ref.config;
    if (!website || !website.appsCodes || !website.appsCodes.length) return null;
    var _appsCodes = _slicedToArray(website.appsCodes, 1), code = _appsCodes[0];
    if (!config.app) return null;
    var _app = config.app, downloadAppBarMessage = _app.downloadAppBarMessage, playStoreURL = _app.playStoreURL, appStoreURL = _app.appStoreURL;
    if (!downloadAppBarMessage) return null;
    if (!playStoreURL) return null;
    if (!appStoreURL) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: "blank",
        onClick: function() {
            return OpenApp({
                code: code,
                playStoreURL: playStoreURL,
                appStoreURL: appStoreURL
            });
        },
        className: (DownloadApp_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (DownloadApp_styles_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DownloadApp_styles_module_default()).description,
                        children: downloadAppBarMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DownloadApp_styles_module_default()).code,
                        children: t("labelDownload")
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/InteligentLink/index.tsx
var InteligentLink = __webpack_require__(76530);
// EXTERNAL MODULE: ./src/helpers/auth/loginViaAuth.ts
var loginViaAuth = __webpack_require__(63601);
// EXTERNAL MODULE: ./src/hooks/useSession.ts
var useSession = __webpack_require__(43001);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Footer/JustoLogo/index.tsx


function JustoLogo(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 780.4 224.7",
        style: style,
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "logos_justo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "st0",
                d: "M311.6,171.3c-11.1,0-19.3-2.2-27-8c-2.2-1.6-2.7-4.8-1-7c0.2-0.3,0.4-0.5,0.6-0.7l8.4-7.8 c1.7-1.6,4.4-1.8,6.3-0.4c3.1,2.3,6.7,3.8,12.6,3.8c11.7,0,19.3-6.5,19.3-19.7V61c0-3.1,2.5-5.6,5.6-5.6l0,0h12.7 c3.1,0,5.6,2.5,5.6,5.6l0,0v71.6C354.9,157.9,334.4,171.3,311.6,171.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "st0",
                d: "M425.2,171.3c-25.2,0-45.2-16-45.2-40.4V60.7c0-2.9,2.3-5.3,5.3-5.3c0,0,0,0,0,0h13.4c2.9,0,5.3,2.4,5.3,5.3 c0,0,0,0,0,0v69.5c0,13.2,8.3,21.2,21.2,21.2s21.4-7.9,21.4-21.2V60.7c0-2.9,2.4-5.3,5.3-5.3c0,0,0,0,0,0H465c2.9,0,5.3,2.4,5.3,5.3 c0,0,0,0,0,0V131C470.3,155.3,450.3,171.3,425.2,171.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "st0",
                d: "M530.8,171.3c-17,0-30.3-3.1-41.7-12.5c-1.5-1.3-1.8-3.6-0.5-5.1c0.1-0.1,0.2-0.2,0.3-0.3l9.7-9.1 c1.6-1.5,4.1-1.6,5.9-0.3c7.4,5.4,16.7,7.2,26.7,7.2c14.1,0,21.7-5,21.7-14.2c0-4-1.2-7.4-3.8-9.7c-2.4-2.1-5.2-3.2-10.9-4 l-14.8-1.9c-10.5-1.5-18.3-4.5-23.8-9.5c-5.8-5.5-8.8-12.9-8.8-22.6c0-20.5,16.2-34.9,42.7-34.9c15.2,0,26.6,3.1,36.4,10.7 c1.6,1.2,1.9,3.5,0.6,5.1c-0.1,0.2-0.3,0.3-0.4,0.4l-9.3,8.6c-1.6,1.5-4,1.6-5.8,0.3c-7.1-4.9-15.1-5.6-22.2-5.6 c-12.8,0-19,6.6-19,14.5c-0.1,3.1,1.3,6.2,3.6,8.2c3.3,2.6,7.2,4.1,11.4,4.5l14.5,1.9c11.2,1.5,18.3,4.4,23.4,8.9 c6.6,5.8,9.5,14.2,9.5,24.4C576.3,158.8,556.5,171.3,530.8,171.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "st0",
                d: "M645.8,75.4v90c0,2.7-2.2,4.9-4.9,4.9h-14.2c-2.7,0-4.9-2.2-4.9-4.9v-90h-27.1c-2.7,0-4.9-2.2-4.9-4.9V60.3 c0-2.7,2.2-4.9,4.9-4.9h78.2c2.7,0,4.9,2.2,4.9,4.9v10.2c0,2.7-2.2,4.9-4.9,4.9H645.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "st0",
                d: "M768.1,158.8c-8.6,8.1-19.1,12.6-33.1,12.6c-14,0-24.6-4.5-33.2-12.6c-12.4-11.6-12.1-26-12.1-45.9 s-0.3-34.2,12.1-45.9c8.6-8.1,19.3-12.6,33.2-12.6c13.9,0,24.5,4.5,33.1,12.6c12.4,11.6,12.2,26,12.2,45.9S780.5,147.1,768.1,158.8z M750.3,80.6c-3.4-3.7-8.8-6.1-15.3-6.1s-12.1,2.4-15.5,6.1c-4.7,4.8-5.8,10.2-5.8,32.3s1.2,27.4,5.8,32.3c3.4,3.7,9,6.1,15.5,6.1 s11.9-2.4,15.3-6.1c4.7-4.8,6-10.2,6-32.3S755,85.4,750.3,80.6L750.3,80.6z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "st0",
                d: "M112.3,0C50.3,0,0,50.3,0,112.3s50.3,112.3,112.3,112.3s112.3-50.3,112.3-112.3S174.4,0,112.3,0L112.3,0z M112.3,23.4c38.8,0,72.1,23.3,86,56.4c3.5,8.3-0.5,17.9-8.8,21.4c-0.2,0.1-0.5,0.2-0.8,0.3c-50.1,18.5-105.1,18.2-155-0.8 c-7.4-2.8-11.2-11.1-8.4-18.5c0-0.1,0-0.1,0.1-0.2C38.8,47.8,72.7,23.4,112.3,23.4L112.3,23.4z M112.3,200c-40,0-74-24.7-86.8-59.2 c-2.6-7.1,4.4-14,11.8-11.7c48.8,15.2,101.2,15.2,150,0c7.4-2.4,14.4,4.6,11.8,11.7C186.4,175.3,152.3,200,112.3,200z"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Footer/Logo/styles.module.css
var Logo_styles_module = __webpack_require__(8099);
var Logo_styles_module_default = /*#__PURE__*/__webpack_require__.n(Logo_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Footer/Logo/index.tsx




function Logo(props) {
    var logo = props.logo, website = props.website;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Logo_styles_module_default()).logo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: logo.url,
            alt: website.name || "Logo",
            title: website.name || "logo",
            objectFit: "contain",
            layout: "fill"
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Footer/SocialMedia/styles.module.css
var SocialMedia_styles_module = __webpack_require__(7521);
var SocialMedia_styles_module_default = /*#__PURE__*/__webpack_require__.n(SocialMedia_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Footer/SocialMedia/index.tsx



function SocialMedia(props) {
    var instagram = props.instagram, facebook = props.facebook, twitter = props.twitter, titleStyle = props.titleStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            instagram || facebook || twitter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                style: titleStyle,
                children: "Redes sociales"
            }) : null,
            instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (SocialMedia_styles_module_default()).link,
                style: titleStyle,
                target: "blank",
                href: instagram,
                children: "Instagram"
            }),
            facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (SocialMedia_styles_module_default()).link,
                style: titleStyle,
                target: "blank",
                href: facebook,
                children: "Facebook"
            }),
            twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (SocialMedia_styles_module_default()).link,
                style: titleStyle,
                target: "blank",
                href: twitter,
                children: "Twitter"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Footer/Terms/styles.module.css
var Terms_styles_module = __webpack_require__(16135);
var Terms_styles_module_default = /*#__PURE__*/__webpack_require__.n(Terms_styles_module);
// EXTERNAL MODULE: ./src/i18n/helpers/terms/getJustoTerms.ts
var getJustoTerms = __webpack_require__(56129);
// EXTERNAL MODULE: ./src/i18n/helpers/terms/removePrefix.ts
var removePrefix = __webpack_require__(90506);
// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(52628);
var values_default = /*#__PURE__*/__webpack_require__.n(values);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Footer/Terms/index.tsx
function Terms_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Terms_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Terms_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Terms_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Terms_slicedToArray(arr, i) {
    return Terms_arrayWithHoles(arr) || Terms_iterableToArrayLimit(arr, i) || Terms_unsupportedIterableToArray(arr, i) || Terms_nonIterableRest();
}
function Terms_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Terms_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Terms_arrayLikeToArray(o, minLen);
}








function Terms(props) {
    var countryCode = props.countryCode, terms = props.terms, titleStyle = props.titleStyle;
    var t = (0,esm/* useTranslation */.$G)("terms").t;
    if (!terms) return null;
    var termsLinks = {};
    var justoTerms = (0,getJustoTerms/* default */.Z)(terms);
    for(var termType in terms){
        var ref = Terms_slicedToArray((0,removePrefix/* default */.Z)(termType, justoTerms), 2), termTypeWithoutPrefix = ref[0], addTerm = ref[1];
        if (addTerm) {
            var title = terms[termType].title;
            termsLinks[termType] = {
                path: "/documentos-legales/".concat(termTypeWithoutPrefix),
                title: title || t("".concat(termTypeWithoutPrefix, ".title"))
            };
        }
    }
    var termsPresent = values_default()(termsLinks);
    if (!termsPresent) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: termsPresent.map(function(link, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InteligentLink/* default */.Z, {
                className: (Terms_styles_module_default()).link,
                style: titleStyle,
                to: link.path,
                moveScrollTo: true,
                children: link.title
            }, index);
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Footer/styles.module.css
var Footer_styles_module = __webpack_require__(20200);
var Footer_styles_module_default = /*#__PURE__*/__webpack_require__.n(Footer_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Footer/index.tsx
function Footer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Footer_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || Footer_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function Footer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Footer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Footer_arrayLikeToArray(o, minLen);
}















function Footer() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.footer"
    }).t;
    var website = (0,useInitialData/* default */.Z)().website;
    var loginWithAuth = (0,loginViaAuth/* useLoginViaAuthWindow */.l)();
    var session = (0,useSession/* default */.Z)();
    var isLogged = Object.keys(session).length !== 0;
    var _footerConfiguration = website.footerConfiguration, logo = _footerConfiguration.logo, instagram = _footerConfiguration.instagram, facebook = _footerConfiguration.facebook, twitter = _footerConfiguration.twitter, links = _footerConfiguration.links, backgroundColor = _footerConfiguration.backgroundColor, textColor = _footerConfiguration.textColor;
    var countryCode = website.countryCode, disableComplaints = website.disableComplaints, justoBrand = website.justoBrand, terms = website.terms, paymentTypesDescription = website.paymentTypesDescription;
    //Cambiar dependiendo si el sitio lo admite
    var defaultLinks = links || [];
    var footerLinks = Object.keys(paymentTypesDescription || {}).length ? _toConsumableArray(defaultLinks).concat([
        {
            path: "/metodos-de-pago/faqs",
            title: "Medios de Pago",
            __typename: "FooterLink",
            httpPostOptions: null
        }
    ]) : _toConsumableArray(defaultLinks);
    var finalLogo = logo || website.logo;
    var titleStyle = {
        color: textColor || "#111"
    };
    var backgroundColorStyle = {
        backgroundColor: backgroundColor || "#eee"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: backgroundColorStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: justoBrand ? (Footer_styles_module_default()).justoBrandContainer : (Footer_styles_module_default()).container,
                style: backgroundColorStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xs-12 col-sm-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Footer_styles_module_default()).logoContainer,
                                    children: finalLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                        website: website,
                                        logo: finalLogo
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-xs-12 col-sm-3",
                                children: [
                                    footerLinks.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        style: titleStyle,
                                        children: t("labelKnowUs")
                                    }) : null,
                                    footerLinks.map(function(link, index) {
                                        return link.httpPostOptions && link.httpPostOptions.enabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            action: link.path,
                                            method: "post",
                                            children: [
                                                (link.httpPostOptions && link.httpPostOptions.parameters || []).map(function(param) {
                                                    var name = param.name, value = param.value;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "hidden",
                                                        name: name,
                                                        value: value
                                                    }, index);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "submit",
                                                    className: (Footer_styles_module_default()).btnLink,
                                                    style: titleStyle,
                                                    children: link.title
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InteligentLink/* default */.Z, {
                                            className: (Footer_styles_module_default()).link,
                                            style: titleStyle,
                                            href: link.path,
                                            children: link.title
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InteligentLink/* default */.Z, {
                                        className: (Footer_styles_module_default()).link,
                                        style: titleStyle,
                                        to: "/info-legal",
                                        children: "Informaci\xf3n Legal"
                                    }, "legal"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms, {
                                        countryCode: countryCode,
                                        terms: terms,
                                        titleStyle: titleStyle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xs-12 col-sm-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMedia, {
                                    instagram: instagram,
                                    facebook: facebook,
                                    twitter: twitter,
                                    titleStyle: titleStyle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-xs-12 col-sm-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        style: titleStyle,
                                        children: t("labelMyAccount")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pedir",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (Footer_styles_module_default()).link,
                                            style: titleStyle,
                                            children: t("labelOrder")
                                        })
                                    }),
                                    website.pointsConfiguration && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/canjear",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (Footer_styles_module_default()).link,
                                            style: titleStyle,
                                            children: website.pointsConfiguration.name
                                        })
                                    }),
                                    isLogged ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/pedidos",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (Footer_styles_module_default()).link,
                                                    style: titleStyle,
                                                    children: t("labelMyOrders")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/settings/addresses",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (Footer_styles_module_default()).link,
                                                    style: titleStyle,
                                                    children: t("labelMyAddresses")
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: loginWithAuth,
                                        className: (Footer_styles_module_default()).link,
                                        style: titleStyle,
                                        children: t("labelSignIn")
                                    }),
                                    countryCode === "PE" && !disableComplaints ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InteligentLink/* default */.Z, {
                                        className: (Footer_styles_module_default()).bookLink,
                                        style: titleStyle,
                                        href: "/reclamos",
                                        moveScrollTo: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Footer_styles_module_default()).rowCenter,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (Footer_styles_module_default()).complaintLogo,
                                                src: "/images/libro_reclamaciones_logo.png",
                                                alt: "Logo Chek"
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            }),
            justoBrand ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Footer_styles_module_default()).center,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "https://getjusto.com/",
                    target: "_blank",
                    rel: "noreferrer",
                    className: (Footer_styles_module_default()).poweredByJusto,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (Footer_styles_module_default()).poweredText,
                            style: {
                                color: titleStyle.color
                            },
                            children: [
                                "Powered by",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JustoLogo, {
                            style: {
                                height: "16px",
                                fill: titleStyle.color,
                                marginLeft: "2px"
                            }
                        })
                    ]
                })
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/ImportantMessage/styles.module.css
var ImportantMessage_styles_module = __webpack_require__(75931);
var ImportantMessage_styles_module_default = /*#__PURE__*/__webpack_require__.n(ImportantMessage_styles_module);
// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/ImportantMessage/index.tsx
function ImportantMessage_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ImportantMessage_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ImportantMessage_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ImportantMessage_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ImportantMessage_slicedToArray(arr, i) {
    return ImportantMessage_arrayWithHoles(arr) || ImportantMessage_iterableToArrayLimit(arr, i) || ImportantMessage_unsupportedIterableToArray(arr, i) || ImportantMessage_nonIterableRest();
}
function ImportantMessage_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ImportantMessage_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ImportantMessage_arrayLikeToArray(o, minLen);
}






function ImportantMessage(props) {
    var ref = ImportantMessage_slicedToArray((0,useSessionStorageState/* default */.Z)("onTable"), 1), onTable = ref[0];
    var website = (0,useInitialData/* default */.Z)().website;
    if (onTable || !website) return null;
    var text = website.navbarConfiguration.importantMessageText;
    if (!text) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ImportantMessage_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ImportantMessage_styles_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImportantMessage_styles_module_default()).description,
                    children: text
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useWebsiteLayout.ts
var useWebsiteLayout = __webpack_require__(18368);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/index.tsx




var layouts = {
    default: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 3904).then(__webpack_require__.bind(__webpack_require__, 73904));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(73904)
                ];
            }
        }
    }),
    taco: dynamic_default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(791), __webpack_require__.e(8354), __webpack_require__.e(8437)]).then(__webpack_require__.bind(__webpack_require__, 24734));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(24734)
                ];
            }
        }
    }),
    tiramisu: dynamic_default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(791), __webpack_require__.e(7502), __webpack_require__.e(4336), __webpack_require__.e(6917), __webpack_require__.e(8449), __webpack_require__.e(8761), __webpack_require__.e(8354), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(3032), __webpack_require__.e(6452), __webpack_require__.e(8819)]).then(__webpack_require__.bind(__webpack_require__, 28067));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(28067)
                ];
            }
        }
    })
};
function Layouts(props) {
    var layout = (0,useWebsiteLayout/* default */.Z)(props.website).layout;
    var Component = layouts[layout];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        children: props.children
    });
};

// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/hooks/useRequestAuthenticate/Context.ts
var Context = __webpack_require__(3221);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/styles.module.css
var ModalInner_styles_module = __webpack_require__(39190);
var ModalInner_styles_module_default = /*#__PURE__*/__webpack_require__.n(ModalInner_styles_module);
// EXTERNAL MODULE: ./src/hooks/useKeyboardEvent.ts
var useKeyboardEvent = __webpack_require__(1626);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/hooks/useLogo.ts
var useLogo = __webpack_require__(31778);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Head/styles.module.css
var Head_styles_module = __webpack_require__(48963);
var Head_styles_module_default = /*#__PURE__*/__webpack_require__.n(Head_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Head/index.tsx






function Head(props) {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.loginWithCode.modal.modalInner.head"
    }).t;
    var logoUrl = (0,useLogo/* default */.Z)({
        darkMode: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Head_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Head_styles_module_default()).secure,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdLock */.Tmq, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Head_styles_module_default()).secureText,
                        children: t("labelSecure")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Head_styles_module_default()).logo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: logoUrl,
                    alt: "Logo de Justo"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/TopText/styles.module.css
var TopText_styles_module = __webpack_require__(57708);
var TopText_styles_module_default = /*#__PURE__*/__webpack_require__.n(TopText_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/TopText/index.tsx




function TopText(props) {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.loginWithCode.modal.modalInner.topText"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TopText_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TopText_styles_module_default()).header,
                children: t("labelHeader")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TopText_styles_module_default()).text,
                children: t("labelText")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Bottom/styles.module.css
var Bottom_styles_module = __webpack_require__(4345);
var Bottom_styles_module_default = /*#__PURE__*/__webpack_require__.n(Bottom_styles_module);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Bottom/Sent/styles.module.css
var Sent_styles_module = __webpack_require__(71960);
var Sent_styles_module_default = /*#__PURE__*/__webpack_require__.n(Sent_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Bottom/Sent/index.tsx




function Sent(props) {
    var email = props.email;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.loginWithCode.modal.modalInner.bottom.sent"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Sent_styles_module_default()).container,
        children: t("labelSentTo", {
            email: email
        })
    });
};

// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Bottom/index.tsx






function Bottom(props) {
    var email = props.email, close = props.close;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.loginWithCode.modal.modalInner.bottom"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Bottom_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sent, {
                email: email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (Bottom_styles_module_default()).cancel,
                onClick: function() {
                    (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.omitLogin);
                    close();
                },
                children: t("labelOmit")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Code/Submit/styles.module.css
var Submit_styles_module = __webpack_require__(29722);
var Submit_styles_module_default = /*#__PURE__*/__webpack_require__.n(Submit_styles_module);
// EXTERNAL MODULE: ./src/components/fields/SixDigitSmallInput/index.tsx
var SixDigitSmallInput = __webpack_require__(77591);
// EXTERNAL MODULE: ./src/providers/apollo/saveJWT.ts + 1 modules
var saveJWT = __webpack_require__(65160);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Code/Submit/index.tsx
function Submit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Submit_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Submit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Submit_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Submit_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function Submit_templateObject() {
    var data = Submit_taggedTemplateLiteral([
        "\n          mutation loginWithCode($email: String, $token: String, $code: String) {\n            session: loginWithCode(email: $email, token: $token, code: $code) {\n              token\n              refreshToken\n            }\n          }\n        "
    ]);
    Submit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function Submit(props) {
    var email = props.email, token = props.token, onSuccess = props.onSuccess;
    var ref = (0,react.useState)(), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var digits = 6;
    var mutate = useMutate_default()();
    var showMessage = (0,useMessage/* default */.Z)();
    var loginWithCode = function() {
        var _ref = Submit_asyncToGenerator(runtime_default().mark(function _callee(code) {
            var session;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return mutate({
                            mutation: (0,lib["default"])(Submit_templateObject()),
                            variables: {
                                email: email,
                                token: token,
                                code: code
                            }
                        });
                    case 4:
                        session = _ctx.sent.session;
                        (0,saveJWT/* default */.Z)(session);
                        onSuccess();
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        showMessage(_ctx.t0);
                    case 12:
                        setLoading(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function loginWithCode(code) {
            return _ref.apply(this, arguments);
        };
    }();
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Submit_styles_module_default()).loadingContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SixDigitSmallInput/* default */.Z, {
            value: value,
            onChange: setValue,
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ value: undefined; onChange: Dispatch<(prev... Remove this comment to see the full error message
            type: SixDigitSmallInput/* default */.Z,
            digits: digits,
            onReady: function(code) {
                return loginWithCode(code);
            }
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Code/styles.module.css
var Code_styles_module = __webpack_require__(80784);
var Code_styles_module_default = /*#__PURE__*/__webpack_require__.n(Code_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/Code/index.tsx
function Code_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Code_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Code_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Code_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Code_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function Code_templateObject() {
    var data = Code_taggedTemplateLiteral([
        "\n          mutation requestLoginCodeCodeLoginInner($email: String) {\n            resultToken: requestLoginCode(email: $email)\n          }\n        "
    ]);
    Code_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function Code(props) {
    var email = props.email, onSuccess = props.onSuccess;
    var ref = (0,react.useState)(), token = ref[0], setToken = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var t = (0,esm/* useTranslation */.$G)("generic").t;
    var showMessage = (0,useMessage/* default */.Z)();
    var mutate = useMutate_default()();
    var requestLoginCode = function() {
        var _ref = Code_asyncToGenerator(runtime_default().mark(function _callee() {
            var resultToken;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return mutate({
                            mutation: (0,lib["default"])(Code_templateObject()),
                            variables: {
                                email: email
                            }
                        });
                    case 4:
                        resultToken = _ctx.sent.resultToken;
                        setToken(resultToken);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        showMessage(_ctx.t0);
                    case 11:
                        setLoading(false);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function requestLoginCode() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        requestLoginCode();
    }, []);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Code_styles_module_default()).loadingContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        });
    }
    if (token) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Submit, {
        onSuccess: onSuccess,
        email: email,
        token: token
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Code_styles_module_default()).retry,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: function() {
                return requestLoginCode();
            },
            children: t("fields.retry")
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/ModalInner/index.tsx








function ModalInner(props) {
    var email = props.email, close = props.close;
    (0,react.useEffect)(function() {
        document.body.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = "unset";
        };
    }, []);
    (0,useKeyboardEvent/* default */.Z)("Escape", close);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ModalInner_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ModalInner_styles_module_default()).modalInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopText, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Code, {
                    email: email,
                    onSuccess: close
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bottom, {
                    email: email,
                    close: close
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/Modal/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function Modal(props) {
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInner, _objectSpread({}, props)), document.querySelector("#modal-root"));
};

;// CONCATENATED MODULE: ./src/page-components/Layout/Website/LoginWithCode/index.tsx
function LoginWithCode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function LoginWithCode_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                LoginWithCode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                LoginWithCode_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function LoginWithCode(props) {
    var ref = (0,react.useState)(), email1 = ref[0], setEmail = ref[1];
    var requestAuthenticate = function() {
        var _ref = LoginWithCode_asyncToGenerator(runtime_default().mark(function _callee(email) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,sleep/* default */.Z)(100);
                    case 2:
                        setEmail(email);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function requestAuthenticate(email) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Context/* default.Provider */.Z.Provider, {
                value: requestAuthenticate,
                children: props.children
            }),
            email1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                email: email1,
                close: function() {
                    setEmail(null);
                }
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/data/fragments/preferences/appOrderPreferences.ts + 1 modules
var appOrderPreferences = __webpack_require__(82339);
// EXTERNAL MODULE: ./src/helpers/misc/getQueryObject.ts
var getQueryObject = __webpack_require__(62280);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/SetPreferences/index.tsx
function SetPreferences_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SetPreferences_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SetPreferences_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SetPreferences_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SetPreferences_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SetPreferences_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SetPreferences_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SetPreferences_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SetPreferences_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SetPreferences_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SetPreferences_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SetPreferences_slicedToArray(arr, i) {
    return SetPreferences_arrayWithHoles(arr) || SetPreferences_iterableToArrayLimit(arr, i) || SetPreferences_unsupportedIterableToArray(arr, i) || SetPreferences_nonIterableRest();
}
function SetPreferences_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SetPreferences_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SetPreferences_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SetPreferences_arrayLikeToArray(o, minLen);
}

function SetPreferences_templateObject() {
    var data = SetPreferences_taggedTemplateLiteral([
        "\n      mutation setUserPreferencesAtLoad(\n        $websiteId: ID\n        $storeId: ID\n        $deliveryType: ID\n        $tableName: String\n        $placeId: ID\n      ) {\n        preferences: setUserPreferences(\n          websiteId: $websiteId\n          deliveryType: $deliveryType\n          storeId: $storeId\n          tableName: $tableName\n          placeId: $placeId\n        ) {\n          _id\n          deliveryType\n          storeId\n          tableName\n          placeId\n          ...appOrderPreferences\n        }\n      }\n      ",
        "\n    "
    ]);
    SetPreferences_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var updatePreferences = function() {
    var _ref = SetPreferences_asyncToGenerator(runtime_default().mark(function _callee(param) {
        var updates, websiteId, mutate;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    updates = param.updates, websiteId = param.websiteId, mutate = param.mutate;
                    _ctx.next = 3;
                    return mutate({
                        mutation: (0,lib["default"])(SetPreferences_templateObject(), appOrderPreferences/* default */.Z),
                        variables: SetPreferences_objectSpread({
                            websiteId: websiteId
                        }, updates)
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updatePreferences(_) {
        return _ref.apply(this, arguments);
    };
}();
function SetPreferences(props) {
    var router = (0,next_router.useRouter)();
    var _query = router.query, deliveryType = _query.deliveryType, storeId = _query.storeId, tableName = _query.tableName, placeId = _query.placeId;
    var onTableParam = router.query.onTable;
    var ref = SetPreferences_slicedToArray((0,useSessionStorageState/* default */.Z)("onTable"), 2), onTable = ref[0], setOnTable = ref[1];
    var ref1 = SetPreferences_slicedToArray((0,useSessionStorageState/* default */.Z)("orderGroupId"), 2), setOrderGroupId = ref1[1];
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var mutate = useMutate_default()();
    (0,react.useEffect)(function() {
        var updates = {};
        var query = (0,getQueryObject/* default */.Z)(router);
        if (onTable) {
            // 3 hours maxTimeOnTable
            // Miliseconds * Seconds * Minutes * Hours
            var maxTimeOnTable = 1000 * 60 * 60 * 3;
            var timeDifference = new Date().valueOf() - new Date(onTable).valueOf();
            if (timeDifference > maxTimeOnTable) {
                setOnTable(null);
                updates.deliveryType = "delivery";
                updates.storeId = null;
            }
        } else {
            if (deliveryType) {
                updates.deliveryType = deliveryType;
                router.replace({
                    pathname: window.location.pathname,
                    query: SetPreferences_objectSpread({}, query, {
                        deliveryType: ""
                    })
                });
            }
            if (placeId) {
                updates.placeId = placeId;
                router.replace({
                    pathname: window.location.pathname,
                    query: SetPreferences_objectSpread({}, query, {
                        placeId: ""
                    })
                });
            }
            if (storeId) {
                updates.storeId = storeId;
                router.replace({
                    pathname: window.location.pathname,
                    query: SetPreferences_objectSpread({}, query, {
                        storeId: ""
                    })
                });
            }
            if (tableName) {
                updates.tableName = tableName;
                router.replace({
                    pathname: window.location.pathname,
                    query: SetPreferences_objectSpread({}, query, {
                        tableName: ""
                    })
                });
            }
            if (onTableParam) {
                updates.onTable = true;
                setOnTable(new Date());
                setOrderGroupId(null);
                router.replace({
                    pathname: window.location.pathname,
                    query: SetPreferences_objectSpread({}, query, {
                        onTable: ""
                    })
                });
            }
        }
        if (!isEmpty_default()(updates)) {
            updatePreferences({
                updates: updates,
                websiteId: websiteId,
                mutate: mutate
            });
        }
    }, [
        router.query
    ]);
    return null;
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/styles.module.css
var Website_styles_module = __webpack_require__(53954);
var Website_styles_module_default = /*#__PURE__*/__webpack_require__.n(Website_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/index.tsx

















function Website(props) {
    var layoutTheme = (0,useIsSpecialLayout/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {}),
                children: props.showDemo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Demo, {}) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {}),
                children: isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadApp, {}) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBanner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportantMessage, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Coupon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SetPreferences, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layouts, {
                website: props.website,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWithCode, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Website_styles_module_default()).child,
                                children: props.children
                            })
                        }),
                        isIFrame/* default */.Z || layoutTheme === "chat" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 93407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FyqFdVRAc2XR7wrRwmZjG","inner":"b1f7Yo0nlDQtcG7y68oQt","description":"_3Mj2dMSCRElzMshDu9EJgy"};

/***/ }),

/***/ 79961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"_1fDaNhCtjd-FpXakwh9Uf3","newOrionLoading":"_16XzDHOt3VBY5SGGpiZ3ZT"};

/***/ }),

/***/ 68732:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line":"_2z8h9VIqWQIynSA7ebMiuS","after":"_2S8rrYzw8a9vQ4yD7xchNy","shimmer":"Spe-oMbOnLeeY3Yo0Jddo"};

/***/ }),

/***/ 21985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"av_HO4OxTx6tj_xWyyeRW","inputs":"v8JQSPF5-HPDZ0K26kv_p","ready":"leSZT3o4bSmEGlfOD6U1J av_HO4OxTx6tj_xWyyeRW primaryBorderColor","inputContainer":"_1REv6Q0AQg0X5g1LxEd-Xa","divider":"_2MjhHKNNOrM6D_ddzH5lSP","input":"_1trz-mkI4NvENNF6fWI_SI"};

/***/ }),

/***/ 33714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_34VFZCXIu_Brz0CgpNvvHw primaryBackgroundColor importantMessageTopBar","inner":"_2DMdNBePT6wYKroM-PEvpU"};

/***/ }),

/***/ 61806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"jUCl0fASoNgOxBbQwdwfK primaryBackgroundColor","inner":"_3hjuKvUPNAui61ND4n_DuE"};

/***/ }),

/***/ 802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3kdHWo-jGkbjX5Ewj--zZW primaryBackgroundColor importantMessageTopBar","inner":"_19mbOsy0TnYyT4LptoXXEp"};

/***/ }),

/***/ 8099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2O-e4SLz7B_qE6-b9ELf53"};

/***/ }),

/***/ 7521:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"ySNtpgF9y8vmS0n8MGmjB"};

/***/ }),

/***/ 16135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"V5qIkUZQ26q8BxYFHabcf"};

/***/ }),

/***/ 20200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1CQ92KRzERwoupIFk_HxHD mainFooter","justoBrandContainer":"_35YLmRMLwuDy9FjBXvSwmH _1CQ92KRzERwoupIFk_HxHD mainFooter","logo":"BwpjgQwqJO1n8V9MkIanL","link":"GhPj1rPfrKtRdgK2ABcIp","btnLink":"_3iOX2Thg3jbITBCz_33w6u","row":"_1kuIWvBy-64cOga392SgVr","rowCenter":"_1PbUJy8OK4fNZPUCnnWGH4","complaintLogo":"_3N9UJGcw7Rc4r3ysBIXiCA","noMargin":"Cb2kzEzOaLAyXKhfegoGQ","marginBook":"_2JTh9NzPtyUMse9zfXamKq","bookLink":"_1k3i4uIN_iYICnSUxM31TG","center":"_2Vjl9aj7Tg7lvAMytjZB3U","poweredByJusto":"_3Z51F85LK3NT1RUXfMQL6j","poweredText":"wM_4D6lA2ZtnI9OOIMK1S","logoContainer":"UY676RAtd2DJ430CO43aC"};

/***/ }),

/***/ 75931:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3cHK0a8IRyo37H0h9PD10R primaryBackgroundColor importantMessageTopBar","inner":"_2jpNLNoZIJRrdPwZ9sIORW"};

/***/ }),

/***/ 71960:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"U892HIOs9S-coLY23Mr5V"};

/***/ }),

/***/ 4345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2SHGnoKESph4T-ZQXLnoRd","cancel":"_2RidwDANDQlxUy9Bk4bRMI"};

/***/ }),

/***/ 29722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"_1GxL2GHWa08Hh3NUnjeVcW"};

/***/ }),

/***/ 80784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"_3XVG4m1gFcUP0kGTdk3QvZ","retry":"_11THiXr2LJg_g3FFr2Mch2"};

/***/ }),

/***/ 48963:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"y0Q919bmQefpeiiZQMyUs","secure":"_3N5W1u1u-FdedsHOV87jkD","secureText":"_38acc5MJuh-Kz_u-go1RTD","logo":"_1LfKMrZHkYM7vKlGasCIZx"};

/***/ }),

/***/ 57708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"VYeGO8eoPZWxTThTnj65-","header":"_1EJJ3-OXY2RC_NH5zI0-DJ","text":"_3H2EidkZkoaTTnZdUNpXWJ"};

/***/ }),

/***/ 39190:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3AZ5ENSS2CnEZ2yCiPpHl_","modalInner":"_2r_ICwsN7Wx9vmg3OaK1l2 shadow"};

/***/ }),

/***/ 53954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"child":"_1szFc3YSDD94llEnRnw-kT"};

/***/ })

}]);